import React from 'react';
import Sym from '../components/Sym';
import SectionHead from '../components/SectionHead';
import ILLUSTRATIONS from './FeatureIllustrations';

/**
 * Las 6 capacidades de PaySlip, en tarjetas. La zona superior de cada tarjeta
 * es el espacio de ilustración (v1 estático con icono; animaciones de marca en
 * fase posterior, decisión §4.10). Copy tomado del HTML del diseño.
 */
export const FEATURES = [
  { icon: 'cloud_download', title: 'Descarga automática del SAT', desc: 'Con tu e.firma, PaySlip baja del SAT los recibos de nómina ya timbrados. Sin buscarlos uno por uno.' },
  { icon: 'groups', title: 'Entrega a cada colaborador', desc: 'Cada persona recibe su recibo en automático. Sin correos, sin archivos que reenviar a mano.' },
  { icon: 'smartphone', title: 'Portal 24/7', desc: 'Tus colaboradores consultan y descargan sus recibos cuando quieran, desde el celular.' },
  { icon: 'dashboard', title: 'Panel para administradores', desc: 'Ve el estatus de entrega de toda la empresa y controla quién accede a qué.' },
  { icon: 'history', title: 'Histórico y respaldo', desc: 'Todos los recibos, ordenados por periodo y respaldados. Nunca vuelvas a perder un PDF o un XML.' },
  { icon: 'search', title: 'Búsqueda al instante', desc: 'Encuentra cualquier recibo por colaborador, RFC o periodo en segundos.' },
];

export const FeatureCard = ({ icon, title, desc }) => {
  const Illustration = ILLUSTRATIONS[icon];
  return (
    <div
      className="reveal"
      style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 20, overflow: 'hidden', transition: 'transform .2s,border-color .2s,box-shadow .2s' }}
      onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.borderColor = 'rgba(111,160,255,.4)'; e.currentTarget.style.boxShadow = '0 24px 48px -24px rgba(47,107,255,.5)'; }}
      onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.boxShadow = 'none'; }}
    >
      <div style={{ position: 'relative', height: 168, display: 'grid', placeItems: 'center', overflow: 'hidden', background: 'radial-gradient(circle at 50% 42%,var(--well-glow),transparent 70%),var(--well)', borderBottom: '1px solid var(--well-border)' }}>
        {Illustration ? <Illustration /> : (
          <span style={{ width: 66, height: 66, borderRadius: 18, background: 'rgba(47,107,255,.14)', border: '1px solid rgba(111,160,255,.28)', display: 'grid', placeItems: 'center' }}>
            <Sym name={icon} size={32} color="#6FA0FF" />
          </span>
        )}
      </div>
      <div style={{ padding: 24 }}>
        <h3 style={{ font: "700 1.2rem 'Source Serif 4'", color: 'var(--heading)', margin: '0 0 8px' }}>{title}</h3>
        <p style={{ font: "400 1rem/1.55 'Hanken Grotesk'", color: 'var(--muted)', margin: 0 }}>{desc}</p>
      </div>
    </div>
  );
};

const Features2 = () => (
  <section style={{ maxWidth: 1200, margin: '0 auto', padding: '40px clamp(20px,5vw,40px)' }}>
    <SectionHead eyebrow="Todo en un solo lugar" title="Del SAT a tu equipo, sin que" accent="muevas un dedo" />
    <div className="ls2-grid3" style={{ marginTop: 40 }}>
      {FEATURES.map((f) => <FeatureCard key={f.title} {...f} />)}
    </div>
  </section>
);

export default Features2;
